import React, { useEffect } from 'react';
import { Link, Redirect } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import AsanConfirmationIcon from "./img/asan-confirmation-icon.svg";
import headerLogo from "./img/header-logo.svg";
import './scss/style.scss';
import { translate } from 'react-i18next';
import { TextField } from '@mui/material';
import { getFormatedDate } from '../../helpers/fotmatDate';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto',
        width: '500px'
    },
}));

function FeedbackModal(props) {
    const classes = useStyles();
    // const [open, setOpen] = React.useState(props.open);

    // const close = () => {
    //     setOpen(false);
    // }

    // useEffectranslate(() => {
    //     setOpen(props.open)
    // }, [props.open])
    return (
        <Modal
            open={props.open}
            onClose={props.closeFunction}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            classes={classes.modal}
            aria-labelledby="spring-modal-title"
            aria-describedby="spring-modal-description">
            <Fade in={props.open}>
                <div className="feedback-modal">
                    <div className="dashboard-contact-section-form dashboard-account-container-component">
                        <TextField variant="outlined" value={props.item?.registerNumber} sx={{ width: 235 }} label={props.t('Reference number')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={props.item?.dateOfShipment} sx={{ width: 235 }} label={props.t('Submission date')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={props.item?.fullName} sx={{ width: 295 }} label={props.t('First name, Last name, Patronymic')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={props.item?.status} sx={{ width: 166 }} label={props.t('Its status')} InputProps={{ readOnly: true }} />
                        <TextField variant="outlined" value={props.item?.responseText} sx={{ width: 482 }} label={props.t('Result')} InputProps={{ readOnly: true }} multiline rows={4} />
                        <TextField variant="outlined" value={props.item?.responseDate} sx={{ width: 172 }} label={props.t('Response date')} InputProps={{ readOnly: true }} />
                        <button className="dashboard-contact-section-button" onClick={props.closeFunction}>{props.t('close')}</button>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}
export default translate("translation")(FeedbackModal);